import { useLayout } from '@hooks/useLayout'
import { LoadingGrid } from '../LoadingGrid'

import type { LoadingPageProps } from './types'

import * as S from './styles'

export const LoadingPage = ({ loading }: LoadingPageProps) => {
  const { isMenuOpen } = useLayout()

  return (
    <>
      {loading && (
        <S.Container isMenuOpen={isMenuOpen}>
          <LoadingGrid />
        </S.Container>
      )}
    </>
  )
}
